import { getAllApplication, getApplicationUsingTagCategory, getEnvironmentTagCategories, getFilterCategoryOption, getGroupChildrenList, getGroupHierarchy, getGroupTypes, getModuleTagCategories, getSkillStreamTagCategories, getTagCategory } from "./apiDataFetcher"

export const fetchInitialAppData = async (dispatch, config, userData) => {
    // getAllApplication(dispatch, config.UNO_URL, userData.token, "all");
    getGroupTypes(dispatch, config.UNO_URL, userData.token);
    getGroupHierarchy(dispatch, config.UNO_URL, userData.user.group.uuid);
    getGroupChildrenList(dispatch, config.UNO_URL, userData.user.group.uuid);
    getModuleTagCategories(dispatch, config.UNO_URL, config.moduleFilterId)
    getEnvironmentTagCategories(dispatch, config.UNO_URL, config.environmentFilterId)
    getSkillStreamTagCategories(dispatch, config.UNO_URL, config.skillStream2DFilterId);
    getApplicationUsingTagCategory(config.UNO_URL, userData.token, config.applicationCategoryId, false, dispatch);
    getTagCategory(dispatch, config.UNO_URL, config.categoryFilterId);
    getFilterCategoryOption(dispatch, config);
}